import { render, staticRenderFns } from "./lawoffotherfind.vue?vue&type=template&id=3b51efbe&scoped=true&"
import script from "./lawoffotherfind.vue?vue&type=script&lang=js&"
export * from "./lawoffotherfind.vue?vue&type=script&lang=js&"
import style0 from "./lawoffotherfind.vue?vue&type=style&index=0&id=3b51efbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51efbe",
  null
  
)

export default component.exports